import React from "react";

import InvoiceGrid from "pages/invoices/component/invoice.grid";
import ActionsPanelComponent from "components/dxf-grid/actions-panel.component";
import {downloadInvoicePdf, getInvoiceDataSource, Invoice, InvoiceStatus} from "pages/invoices/invoices.service";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useMutation} from "react-query";

const PaidInvoicePage = () => {
  const dataSource = React.useMemo(() => getInvoiceDataSource(InvoiceStatus.Paid), []);
  return <InvoiceGrid dataSource={dataSource} actions={InvoiceActions} invoiceStatus="paid" />;
};

function InvoiceActions({ data }: any) {
  const {t} = useTranslation('invoices');
  const navigate = useNavigate();

  const invoice = data as Invoice;
  const downloadPdfMutation = useMutation(() => downloadInvoicePdf(invoice))

  const actions = [
    {
      label: t('download'),
      action: () => downloadPdfMutation.mutate()
    },
    {
      label: t('need-help-with-invoice'),
      action: () => navigate('/tickets',{state:{isAddingTicket:true,invoice}})
    }
  ];
  return <ActionsPanelComponent actions={actions} isLoading={downloadPdfMutation.isLoading} />;
}

export default PaidInvoicePage;
